import { createNode } from '@glueapp/graph-types';

export const ExclusiveOr = createNode({
    id: 'ExclusiveOr',
    name: 'ExclusiveOr',
    description: 'Puts out true if only one of the input values is true',
    aiDescription:
        'Logical XOR of two booleans. Connect values to "Input1" and "Input2" ports; the "Output" port returns true if exactly one input is true.',
    category: 'Logic',
    color: '#cd6205',
    integration: undefined,
    inPorts: {
        Input1: {
            kind: 'boolean',
        },
        Input2: {
            kind: 'boolean',
        },
    },
    outPorts: {
        Output: {
            kind: 'boolean',
        },
    },
    execute: function (input) {
        const inputValue1 = input.inPorts.Input1;
        const inputValue2 = input.inPorts.Input2;

        return { output: { Output: inputValue1 !== inputValue2 } };
    },
});
